(function () {
  let productsCache = null;
  let catalogRequest = null;

  function fetchCatalog() {
    if (productsCache) return Promise.resolve(productsCache);
    // Every caller shares the one in-flight request (pointerenter, focusin and each keystroke used to start
    // their own products.json fetch before the first one finished).
    if (catalogRequest) return catalogRequest;
    const cached = sessionStorage.getItem('ps_products_cache');
    if (cached) {
      try {
        productsCache = JSON.parse(cached);
        return Promise.resolve(productsCache);
      } catch (e) {}
    }
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const fetchUrl = (rootUrl.endsWith('/') ? rootUrl : rootUrl + '/') + 'products.json?limit=250';
    catalogRequest = fetch(fetchUrl)
      .then((res) => res.json())
      .then((data) => {
        productsCache = data.products || [];
        try {
          sessionStorage.setItem('ps_products_cache', JSON.stringify(productsCache));
        } catch (e) {}
        return productsCache;
      })
      .catch(() => [])
      .finally(() => {
        catalogRequest = null;
      });
    return catalogRequest;
  }

  function parseDimensions(title) {
    let mm = null;
    let inches = null;

    const mmParenMatch = title.match(/\((\d+(?:\.\d+)?)\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)(?:\s*(?:x|×|X)\s*(\d+(?:\.\d+)?))?\s*mm\)/i);
    if (mmParenMatch) {
      mm = [parseFloat(mmParenMatch[1]), parseFloat(mmParenMatch[2]), mmParenMatch[3] ? parseFloat(mmParenMatch[3]) : 0];
    }

    const mmDirectMatch = title.match(/(\d+(?:\.\d+)?)\s*(?:mm)?\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*(?:mm)?(?:\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*mm)/i);
    if (!mm && mmDirectMatch) {
      mm = [parseFloat(mmDirectMatch[1]), parseFloat(mmDirectMatch[2]), parseFloat(mmDirectMatch[3])];
    }

    const mmSuffixMatch = title.match(/(\d+(?:\.\d+)?)\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*mm/i);
    if (!mm && mmSuffixMatch) {
      mm = [parseFloat(mmSuffixMatch[1]), parseFloat(mmSuffixMatch[2]), parseFloat(mmSuffixMatch[3])];
    }

    const mm2DMatch = title.match(/(\d+(?:\.\d+)?)\s*(?:mm)?\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*mm\b/i);
    if (!mm && mm2DMatch) {
      mm = [parseFloat(mm2DMatch[1]), parseFloat(mm2DMatch[2]), 0];
    }

    const inMatch = title.match(/(\d+(?:\.\d+)?)\s*(?:["”]|inch(?:es)?)?\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*(?:["”]|inch(?:es)?)?(?:\s*(?:x|×|X)\s*(\d+(?:\.\d+)?)\s*(?:["”]|inch(?:es)?)?)?/i);
    if (!mm && inMatch && (title.includes('"') || title.includes('”') || title.toLowerCase().includes('inch') || inMatch[3])) {
      if (!title.startsWith('(') && !title.includes('mm x')) {
        inches = [parseFloat(inMatch[1]), parseFloat(inMatch[2]), inMatch[3] ? parseFloat(inMatch[3]) : 0];
      }
    }

    if (mm && !inches) {
      inches = mm.map((v) => +(v / 25.4).toFixed(2));
    } else if (inches && !mm) {
      mm = inches.map((v) => Math.round(v * 25.4));
    }

    return { mm, inches };
  }

  function initSizeSearch() {
    const containers = document.querySelectorAll('.size-search-container');
    if (!containers.length) return;

    // Speed: the product list (about 35 KB of JSON) loads only when a shopper starts
    // using the size search, not on every page load.
    containers.forEach((c) => {
      c.addEventListener('pointerenter', fetchCatalog, { once: true });
      c.addEventListener('focusin', fetchCatalog, { once: true });
    });

    containers.forEach((container) => {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      const inputs = container.querySelectorAll('.size-search-input');
      const popup = container.querySelector('.size-search-popup');
      const closeBtn = container.querySelector('.size-search-popup-close');
      const unitBtns = container.querySelectorAll('.size-search-unit-btn');
      const categoryBtns = container.querySelectorAll('.size-search-category-btn');
      const radioInputs = container.querySelectorAll('input[type="radio"]');
      const resultsContainer = container.querySelector('.size-search-results');
      const resultsTitle = container.querySelector('.size-search-results-title');
      const resultsCount = container.querySelector('.size-search-results-count');
      const resultsList = container.querySelector('.size-search-results-list');
      const hintContainer = container.querySelector('.size-search-hint');
      const hintText = container.querySelector('.size-search-hint-text');
      const hintBtn = container.querySelector('.size-search-hint-btn');

      let currentUnit = 'MM';
      const activeUnitEl = container.querySelector('.size-search-unit-btn.is-active');
      if (activeUnitEl && activeUnitEl.dataset.unit) {
        currentUnit = activeUnitEl.dataset.unit;
      }

      function setUnit(unit) {
        currentUnit = unit;
        unitBtns.forEach((b) => {
          if (b.dataset.unit === unit) {
            b.classList.add('is-active');
          } else {
            b.classList.remove('is-active');
          }
        });
        updateResults();
      }

      function openPopup() {
        if (popup) {
          popup.classList.remove('hidden');
          updateResults();
        }
      }

      function closePopup() {
        if (popup) {
          popup.classList.add('hidden');
        }
      }

      function getSelectedCategories() {
        const cats = [];
        container.querySelectorAll('.size-search-category-btn.is-active').forEach((btn) => {
          if (btn.dataset.category) cats.push(btn.dataset.category);
        });
        return cats;
      }

      function getProductSizeMode() {
        const checked = container.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : 'approx';
      }

      function findMatches(products) {
        const inputL = container.querySelector('.size-search-input--l');
        const inputW = container.querySelector('.size-search-input--w');
        const inputH = container.querySelector('.size-search-input--h');

        const valL = parseFloat(inputL ? inputL.value : '') || 0;
        const valW = parseFloat(inputW ? inputW.value : '') || 0;
        const valH = parseFloat(inputH ? inputH.value : '') || 0;

        if (!valL && !valW && !valH) return null;

        let reqMm = [valL, valW, valH];
        if (currentUnit === 'IN') reqMm = reqMm.map((v) => v * 25.4);
        if (currentUnit === 'CM') reqMm = reqMm.map((v) => v * 10);
        if (currentUnit === 'M') reqMm = reqMm.map((v) => v * 1000);

        const reqSorted = [...reqMm].sort((a, b) => b - a);
        const reqSum = reqSorted[0] + reqSorted[1] + (reqSorted[2] || 0);
        const categories = getSelectedCategories();
        const mode = getProductSizeMode();

        const matches = [];

        products.forEach((p) => {
          const titleLower = p.title.toLowerCase();
          const tagsLower = (p.tags || []).map((t) => (typeof t === 'string' ? t.toLowerCase() : '')).join(' ');

          let matchesCategory = false;
          if (!categories.length) {
            matchesCategory = true;
          } else {
            if (categories.includes('Boxes') && (titleLower.includes('box') || tagsLower.includes('box'))) matchesCategory = true;
            if (categories.includes('Bags') && (titleLower.includes('bag') || tagsLower.includes('bag') || tagsLower.includes('mail'))) matchesCategory = true;
            if (categories.includes('Postal') && (titleLower.includes('postal') || titleLower.includes('mail') || tagsLower.includes('mail') || titleLower.includes('letter'))) matchesCategory = true;
          }

          if (!matchesCategory) return;

          (p.variants || []).forEach((v) => {
            const dims = parseDimensions(v.title);
            if (!dims.mm) return;

            const varSorted = [...dims.mm].sort((a, b) => b - a);
            const diffSum = Math.abs(varSorted[0] - reqSorted[0]) +
                            Math.abs(varSorted[1] - reqSorted[1]) +
                            Math.abs((varSorted[2] || 0) - (reqSorted[2] || 0));
            const isExact = diffSum < 4;

            const UNDERSIZE_PENALTY = 3;
            let rankScore = 0;
            for (let i = 0; i < 3; i++) {
              const axisDiff = (varSorted[i] || 0) - (reqSorted[i] || 0);
              rankScore += axisDiff >= 0 ? axisDiff : Math.abs(axisDiff) * UNDERSIZE_PENALTY;
            }

            if (mode === 'minimum') {
              const fits = varSorted[0] >= reqSorted[0] &&
                           varSorted[1] >= reqSorted[1] &&
                           (reqSorted[2] === 0 || varSorted[2] >= reqSorted[2]);
              if (fits) {
                const excessVolume = (varSorted[0] * varSorted[1] * (varSorted[2] || 1)) - (reqSorted[0] * reqSorted[1] * (reqSorted[2] || 1));
                matches.push({
                  productTitle: p.title,
                  handle: p.handle,
                  variantTitle: v.title,
                  variantId: v.id,
                  price: v.price,
                  image: (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '',
                  mm: dims.mm,
                  inches: dims.inches,
                  diff: excessVolume,
                  diffSum: diffSum,
                  isExact: isExact
                });
              }
            } else {
              const maxAllowedDiff = Math.max(55, reqSum * 0.45);
              const isClose = diffSum <= maxAllowedDiff;

              if (isClose) {
                matches.push({
                  productTitle: p.title,
                  handle: p.handle,
                  variantTitle: v.title,
                  variantId: v.id,
                  price: v.price,
                  image: (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '',
                  mm: dims.mm,
                  inches: dims.inches,
                  diff: diffSum,
                  diffSum: diffSum,
                  rankScore: rankScore,
                  isExact: isExact
                });
              }
            }
          });
        });

        if (mode === 'minimum') {
          matches.sort((a, b) => {
            if (a.isExact && !b.isExact) return -1;
            if (!a.isExact && b.isExact) return 1;
            return a.diff - b.diff;
          });
        } else {
          matches.sort((a, b) => {
            if (a.isExact && !b.isExact) return -1;
            if (!a.isExact && b.isExact) return 1;
            return a.rankScore - b.rankScore;
          });
        }

        return {
          matches: matches,
          valL: valL,
          valW: valW,
          valH: valH
        };
      }

      function updateResults() {
        if (!resultsContainer) return;
        fetchCatalog().then((products) => {
          const resultData = findMatches(products);
          if (!resultData) {
            resultsContainer.classList.add('hidden');
            if (hintContainer) hintContainer.classList.add('hidden');
            return;
          }

          const matches = resultData.matches;
          const valL = resultData.valL;
          const valW = resultData.valW;
          const valH = resultData.valH;

          if (hintContainer && hintText && hintBtn) {
            if (currentUnit === 'MM' && valL > 0 && valL <= 35 && valW > 0 && valW <= 35) {
              hintText.textContent = '💡 Did you mean ' + valL + ' × ' + valW + (valH ? ' × ' + valH : '') + ' inches?';
              hintBtn.textContent = 'Switch to inches';
              hintBtn.onclick = function (e) {
                e.preventDefault();
                setUnit('IN');
              };
              hintContainer.classList.remove('hidden');
            } else if (currentUnit === 'IN' && valL >= 75) {
              hintText.textContent = '💡 Did you mean ' + valL + ' × ' + valW + (valH ? ' × ' + valH : '') + ' mm?';
              hintBtn.textContent = 'Switch to mm';
              hintBtn.onclick = function (e) {
                e.preventDefault();
                setUnit('MM');
              };
              hintContainer.classList.remove('hidden');
            } else {
              hintContainer.classList.add('hidden');
            }
          }

          resultsContainer.classList.remove('hidden');
          resultsList.innerHTML = '';

          const mode = getProductSizeMode();

          if (matches.length === 0) {
            resultsTitle.textContent = 'No matching sizes found';
            resultsCount.textContent = '0 items';
            const unitLabel = currentUnit === 'IN' ? 'inches' : currentUnit.toLowerCase();
            resultsList.innerHTML = '<div class="size-search-no-results">No in-stock packaging found matching ' + valL + ' × ' + (valW || valL) + (valH ? ' × ' + valH : '') + ' ' + unitLabel + '. Try adjusting the dimensions or switching between inches and mm.</div>';
            return;
          }

          const hasExact = matches.some((m) => m.isExact);
          resultsTitle.textContent = hasExact ? 'Exact and Closest Matches' : (mode === 'minimum' ? 'Best-Fitting Packaging' : 'Closest Available Sizes');
          resultsCount.textContent = matches.length + ' found';

          const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
          const baseProductUrl = (rootUrl.endsWith('/') ? rootUrl : rootUrl + '/') + 'products/';

          matches.forEach((m) => {
            const item = document.createElement('a');
            item.className = 'size-search-result-item';
            item.href = baseProductUrl + m.handle + '?variant=' + m.variantId;

            let imgHtml = '';
            if (m.image) {
              imgHtml = '<img src="' + m.image + '" class="size-search-result-img" alt="' + m.productTitle.replace(/"/g, '&quot;') + '" width="40" height="40" loading="lazy">';
            } else {
              imgHtml = '<div class="size-search-result-img flex items-center justify-center bg-white text-gray-400 text-xs">📦</div>';
            }

            let badgeHtml = '';
            if (m.isExact) {
              badgeHtml = '<span class="size-search-result-badge">Exact match</span>';
            } else if (mode === 'minimum') {
              badgeHtml = '<span class="size-search-result-badge is-best-fit">Fits product</span>';
            }

            let formattedPrice = '£' + parseFloat(m.price).toFixed(2);
            if (window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol) {
              formattedPrice = window.Shopify.currency.symbol + parseFloat(m.price).toFixed(2);
            }

            item.innerHTML = imgHtml +
              '<div class="size-search-result-info">' +
                '<div class="size-search-result-product">' + m.productTitle + '</div>' +
                '<div class="size-search-result-variant">' + m.variantTitle + '</div>' +
                badgeHtml +
              '</div>' +
              '<div class="size-search-result-price">' + formattedPrice +
                ' <span class="size-search-result-vat">ex VAT</span></div>';

            resultsList.appendChild(item);
          });
        });
      }

      inputs.forEach((input) => {
        input.addEventListener('focus', (e) => {
          e.stopPropagation();
          openPopup();
        });
        input.addEventListener('click', (e) => {
          e.stopPropagation();
          openPopup();
        });
        input.addEventListener('input', () => {
          openPopup();
          updateResults();
        });
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            fetchCatalog().then((products) => {
              const resultData = findMatches(products);
              if (resultData && resultData.matches && resultData.matches.length > 0) {
                const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                  ? window.Shopify.routes.root
                  : '/';
                const baseProductUrl = (rootUrl.endsWith('/') ? rootUrl : rootUrl + '/') + 'products/';
                const topMatch = resultData.matches[0];
                window.location.href = baseProductUrl + topMatch.handle + '?variant=' + topMatch.variantId;
              }
            });
          }
        });
      });

      if (popup) {
        popup.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closePopup();
        });
      }

      document.addEventListener('click', (e) => {
        if (!container.contains(e.target)) {
          closePopup();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closePopup();
        }
      });

      unitBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          setUnit(btn.dataset.unit || 'MM');
        });
      });

      categoryBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          btn.classList.toggle('is-active');
          updateResults();
        });
      });

      radioInputs.forEach((radio) => {
        radio.addEventListener('change', () => {
          updateResults();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeSearch);
  } else {
    initSizeSearch();
  }

  document.addEventListener('shopify:section:load', initSizeSearch);
})();
